import Rete from 'rete'

import { lang } from '../../assets/lang'
import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import CarouselTemplate from './CarouselTemplate'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;

export default class CarouselComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.CAROUSEL)

    this.data.component = CarouselTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !! window.xitFlowBuilderData.is_openai_addon_access
    this.isConditionAddonAvailable = !!window.xitFlowBuilderData.messenger_bot_condition
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder(node) {
    node.lingualName = lingualName.CAROUSEL
    this.setConnection()

    const carouselInput = new Rete.Input(CONST_SOCKET.CAROUSEL_INPUT, lang.carousel_socket_input_reply, this.socket.carouselInput, true)
    const carouselOutput = new Rete.Output(CONST_SOCKET.CAROUSEL_OUTPUT, lang.carousel_socket_output_next, this.socket.carouselOutput, false)
    const carouselOutputItems = new Rete.Output(CONST_SOCKET.CAROUSEL_OUTPUT_ITEMS, lang.carousel_socket_output_items, this.socket.carouselOutputItems, true)
    const carouselOutputQuickreply = new Rete.Output(CONST_SOCKET.CAROUSEL_OUTPUT_QUICKREPLY, lang.carousel_socket_output_quick_replies, this.socket.carouselOutputQuickreply, true)

    node.addInput(carouselInput)
    node.addOutput(carouselOutput)
    node.addOutput(carouselOutputItems)

    if (! instagram_addon) {
      node.addOutput(carouselOutputQuickreply)
    }

    return node
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.CAROUSEL_OUTPUT] = node.data
    outputs[CONST_SOCKET.CAROUSEL_OUTPUT_ITEMS] = node.data
  }
  
  setConnection() {
    // Carousel may be connected to:
    this.socket.carouselOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.carouselOutput.combineWith(this.socket.openaiInput)
    this.socket.carouselOutput.combineWith(this.socket.carouselInput)
    this.socket.carouselOutput.combineWith(this.socket.imageInput)
    this.socket.carouselOutput.combineWith(this.socket.videoInput)
    this.socket.carouselOutput.combineWith(this.socket.audioInput)

    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.carouselOutput.combineWith(this.socket.conditionInput)
    }

    if (!this.isInstagramAddonAvailable) {
      this.socket.carouselOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.carouselOutput.combineWith(this.socket.fileInput)
      this.socket.carouselOutput.combineWith(this.socket.otnInput)
    }
    
    if(recurring_notification_display)
      this.socket.carouselOutput.combineWith(this.socket.rcnInput)

    this.socket.carouselOutput.combineWith(this.socket.ecommerceInput)
    this.socket.carouselOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.carouselOutput.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.carouselOutput.combineWith(this.socket.httpApiInput)
    }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.carouselOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (CarouselItem): CarouselItem
    this.socket.carouselOutputItems.combineWith(this.socket.carouselSingleInput)
    this.socket.carouselOutputQuickreply.combineWith(this.socket.quickReplyInput)    
  }
}